import * as userSlice from '../../data/user.slice';
import { useAppSelector } from '../useAppSelector';

export function useFeatureEnabled(featureName: string): boolean {
  const loggedInUser = useAppSelector(userSlice.selectLoggedInUserInfo);
  const featureFlags = loggedInUser?.featureFlags || [];
  return featureFlags.includes(featureName);
}
